import React from "react";
import { Routes, Route } from "react-router-dom";
import SubPage from "components/pages/flooring/sub-pages";
import type { TFlooring } from "components/flooring/helpers/flooring-types-helper";
import { PermissionGuard } from "components/permissions";
import { Pages } from "components/pages";
import Flooring from "components/flooring";

interface IFlooringRouteProps
{
  flooring: TFlooring | undefined;
}

const FlooringRoute: React.FC<IFlooringRouteProps> = ({ flooring }) =>
{
  return (
    <PermissionGuard
      permission={Flooring.Const.permissions.VIEW}
      fallback={<Pages.Page403 />}
    >
      <Routes>
        <Route path="/" element={<SubPage.OverView flooring={flooring} />} />
      </Routes>
    </PermissionGuard>
  );
};

export default FlooringRoute;
